<huron-layout id="main-content" [sideNavItems]="sideNavItems">  
  <div page-content class="page-content">      
  </div>

 
</huron-layout>

<hhsg-shared-modal [isActive]="sessionExpiring" (acceptEvent)="extendSession()" (rejectEvent)="extendSession()"
    [disableFooter]="false" [disableHeader]="true" acceptText="Keep Working" acceptCssClass="button primary"
    rejectCssClass="button cancel"  [type] ="'medium'">
    <div role="body">
      {{ sessionMessage }}
    </div>
</hhsg-shared-modal>